module.exports = __webpack_public_path__ + "static/media/payment-success.2bc402e9.png";